import {ChangeDetectionStrategy, Component, inject, input, output} from '@angular/core';
import {CommonModule} from '@angular/common';
import {TranslateModule} from '@ngx-translate/core';
import {ChatMessageListComponent} from '../chat-message-list/chat-message-list.component';
import {ChatInputComponent} from '../chat-input/chat-input.component';
import {AiChatFacade} from '../../ai-chat.facade';

@Component({
  selector: 'app-chat-sidebar',
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    ChatMessageListComponent,
    ChatInputComponent,
  ],
  templateUrl: './chat-sidebar.component.html',
  styleUrl: './chat-sidebar.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChatSidebarComponent {
  /**
   * Facade providing all chat state and operations.
   *
   * Exposed to template as `facade.*` for message list, input, and suggestions.
   * Child components (ChatInputComponent, ChatMessageListComponent) receive
   * individual bindings from facade but can also inject it directly.
   */
  protected readonly facade = inject(AiChatFacade);

  // ── Layout inputs (controlled by parent ChatComponent) ──────────────────────
  isCollapsed = input<boolean>(false);
  isMobileOpen = input<boolean>(false);
  isSmallScreen = input<boolean>(false);

  // ── Layout output (emitted to parent) ────────────────────────────────────────
  togglePanel = output<void>();
}
